import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency'
})
export class CurrencyPipe implements PipeTransform {

  transform(value: number, currencySymbol: string = '$'): string {
    if (isNaN(value)) {
      return '';
    }

    let formattedValue: string;
    let fractionSize: number = 2

    // Check if the value has decimal places
    if (value % 1 === 0) {
      // If it's a whole number, format with 2 decimal places
      formattedValue = value.toFixed(fractionSize);
    } else if (Math.floor(value * Math.pow(10, fractionSize)) === value * Math.pow(10, fractionSize)) {
      // If it has less than or equal to fractionSize decimal places, apply toFixed
      formattedValue = value.toFixed(fractionSize);
    } else {
      // If it has more decimal places than fractionSize, don't round or truncate
      formattedValue = value.toString();
    }

    return `${currencySymbol}${formattedValue}`;
  }
}
